import {createFileRoute} from '@tanstack/react-router';

import {ChecklistTemplateLibrary} from '@/features/Library/components/ChecklistTemplate/ChecklistTemplateLibrary';
import {makeDocumentTitle} from '@/utils/makeDocumentTitle';

export const Route = createFileRoute('/_b/_p/_library/checklists')({
  component: ChecklistTemplateLibrary,
  beforeLoad: () => makeDocumentTitle('Checklists'),
});
